import * as tslib_1 from "tslib";
import getUserConfigurationOperation from 'owa-service/lib/operation/getUserConfigurationOperation';
import getUserConfigurationRequest from 'owa-service/lib/factory/getUserConfigurationRequest';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import getMailboxExportUserConfigurationName from './getMailboxExportUserConfigurationName';
export default function getDefaultMailboxExportStatus() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getUserConfigurationOperation({
                        Header: getJsonRequestHeader(),
                        Body: getUserConfigurationRequest({
                            UserConfigurationName: getMailboxExportUserConfigurationName(),
                            UserConfigurationProperties: 'Dictionary',
                        }),
                    })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.Body.ResponseMessages.Items[0]];
            }
        });
    });
}
//# sourceMappingURL=getMailboxExportStatus.js.map